/**
 * pkwv2 erfasst die ÖPNV-Jahreskarte als Einfachauswahl, weil Softfair V2 genau eine Karte
 * annimmt. Gesendet und gespeichert wird weiterhin das V1-Objekt aus drei Booleans; dieses Modul
 * übersetzt in beide Richtungen. Beide Richtungen liegen zusammen, damit die Reihenfolge unten
 * nur an einer Stelle steht.
 */

export const JAHRESKARTE_OEPNV_TYP = {
  BAHN_COMFORT: 'bahnComfort',
  BAHN_NORMAL: 'bahnNormal',
  SONSTIGE: 'sonstige',
} as const;

export type JahreskarteOepnvTyp =
  (typeof JAHRESKARTE_OEPNV_TYP)[keyof typeof JAHRESKARTE_OEPNV_TYP];

export interface JahreskarteOepnvFlags {
  bahnComfort: boolean;
  bahnNormal: boolean;
  sonstige: boolean;
}

/**
 * Reihenfolge, wenn ein Altangebot mehrere Karten trägt. Fachlich gibt es keine Rangfolge –
 * Softfair mappt die drei Werte ohne Treppen-Logik auf 0/1/2. Die Reihenfolge ist eine Setzung und
 * stimmt mit dem Tarifservice-Mapper überein, damit Formular und Schnittstelle dieselbe Karte
 * wählen.
 */
const REIHENFOLGE: JahreskarteOepnvTyp[] = [
  JAHRESKARTE_OEPNV_TYP.BAHN_COMFORT,
  JAHRESKARTE_OEPNV_TYP.BAHN_NORMAL,
  JAHRESKARTE_OEPNV_TYP.SONSTIGE,
];

/**
 * Nimmt `string`, weil das Schema den Wert als `string` fuehrt. Ein unbekannter Wert faellt auf
 * BahnNormal zurueck – so kann nie ein Objekt mit drei `false` entstehen.
 */
export const flagsAusTyp = (typ: string): JahreskarteOepnvFlags => {
  const gewaehlt = REIHENFOLGE.includes(typ as JahreskarteOepnvTyp)
    ? (typ as JahreskarteOepnvTyp)
    : JAHRESKARTE_OEPNV_TYP.BAHN_NORMAL;

  return {
    bahnComfort: gewaehlt === JAHRESKARTE_OEPNV_TYP.BAHN_COMFORT,
    bahnNormal: gewaehlt === JAHRESKARTE_OEPNV_TYP.BAHN_NORMAL,
    sonstige: gewaehlt === JAHRESKARTE_OEPNV_TYP.SONSTIGE,
  };
};

/**
 * Mehrere gesetzte Karten werden auf die erste der Reihenfolge reduziert, keine gesetzte Karte
 * fällt auf BahnNormal zurück – denselben Default trägt das Formularfeld.
 */
export const typAusFlags = (
  flags: Partial<JahreskarteOepnvFlags> | undefined,
): JahreskarteOepnvTyp =>
  REIHENFOLGE.find((typ) => flags?.[typ] === true) ??
  JAHRESKARTE_OEPNV_TYP.BAHN_NORMAL;
